export enum TabType {
  QUALITY_MONITOR = 'quality-monitor',
  MESSAGES = 'messages',
  DASHBOARD = 'dashboard',
  TRAVEL_EXPENSE_CLAIMS = 'travel-expense-claims',
  TRAVEL_MOVEMENTS = 'travel-movements',
  DAY_LIMIT_VIOLATIONS = 'day-limit-violations',
  ADDITIONAL_COMPENSATIONS = 'additional-compensations',
  ABSENCE_NOTICES = 'absence-notices',
  EXPIRING_EMPLOYMENT_CONTRACTS = 'expiring-employment-contracts',
  END_OF_EMPLOYMENT_SETTLEMENTS = 'end-of-employment-settlements',
  AI_MATCH = 'ai-match'
}
